// extracted by mini-css-extract-plugin
export default {"UpdateKey":"UpdateKey_UpdateKey__0tBew","form":"UpdateKey_form__oNHPf"};